import type { TFunction } from "i18next";
import { z } from "zod";

export const BOOLEAN_ENUM = ["true", "false"] as const;
export type BooleanEnum = (typeof BOOLEAN_ENUM)[number];

export const getStep5Schema = (t: TFunction) =>
  z
    .object({
      companyName: z
        .string({
          message: t("step5.validation.companyName"),
        })
        .trim()
        .min(1, t("step5.validation.companyName")),
      firstName: z
        .string({
          message: t("step5.validation.firstName"),
        })
        .trim()
        .min(1, t("step5.validation.firstName")),
      lastName: z
        .string({
          message: t("step5.validation.lastName"),
        })
        .trim()
        .min(1, t("step5.validation.lastName")),
      email: z.email(t("step5.validation.invalidEmail")),
      phone: z
        .string()
        .trim()
        .optional()
        .refine(val => !val || /^\+?\d{9,15}$/.test(val), t("step5.validation.invalidPhone")),
      privacyPolicyRodo: z.enum(BOOLEAN_ENUM, {
        message: t("step5.validation.privacyPolicyRodoRequired"),
      }),
      marketingEmailConsent: z.enum(BOOLEAN_ENUM).optional(),
      marketingPhoneConsent: z.enum(BOOLEAN_ENUM).optional(),
      newsletterConsent: z.enum(BOOLEAN_ENUM).optional(),
      dataProcessingConsent: z.enum(BOOLEAN_ENUM, {
        message: t("step5.validation.dataProcessingConsentRequired"),
      }),
      dataAccuracyResponsibilityConsent: z.enum(BOOLEAN_ENUM, {
        message: t("step5.validation.dataAccuracyResponsibilityConsentRequired"),
      }),
    })

    .superRefine((data, ctx) => {
      if (data.privacyPolicyRodo !== "true") {
        ctx.addIssue({
          code: "custom",
          path: ["privacyPolicyRodo"],
          message: t("step5.validation.privacyPolicyRodoRequired"),
        });
      }

      if (data.dataProcessingConsent !== "true") {
        ctx.addIssue({
          code: "custom",
          path: ["dataProcessingConsent"],
          message: t("step5.validation.dataProcessingConsentRequired"),
        });
      }

      if (data.dataAccuracyResponsibilityConsent !== "true") {
        ctx.addIssue({
          code: "custom",
          path: ["dataAccuracyResponsibilityConsent"],
          message: t("step5.validation.dataAccuracyResponsibilityConsentRequired"),
        });
      }
    });

export type Step5Schema = z.infer<ReturnType<typeof getStep5Schema>>;

export type Step5FormKeys = keyof Step5Schema;
